import {
  Input,
  Component,
  ElementRef,
  ViewContainerRef,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

export type IconButtonSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
export type IconButtonVariant = 'base' | 'primary' | 'outlined';
export type IconButtonShape = 'circle' | 'square';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[app-icon-button], a[app-icon-button]',
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '_getButtonClasses()',
  },
})
export class IconButtonComponent {
  @Input()
  size: IconButtonSize = 'medium';

  @Input()
  variant: IconButtonVariant = 'base';

  @Input()
  shape: IconButtonShape = 'square';

  constructor(
    public elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
  ) {}

  _getButtonClasses() {
    return `icon-button icon-button_${this.size} icon-button_${this.variant} icon-button_${this.shape}`;
  }
}
